import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Img1 from '../photos/WhatsApp-Image-2026-08-10-at-3.15.21-PM.jpeg';
import Img2 from '../photos/WhatsApp Image 2026-09-11 at 4.37.20 PM.jpeg';
import Img3 from '../photos/WhatsApp-Image-2024-08-31-at-15.51.49.jpeg';
import Img4 from '../photos/WhatsApp-Image-2024-08-31-at-15.51.07-1.jpeg';
import Img5 from '../photos/jswa-electronics.jpg'
import SharmaPortrait from '../photos/mlsharma.jpg';
import VivekPortrait from '../photos/vivek bansal.png';
import GirishPortrait from '../photos/Girish.jpg';
const HERO_IMAGES = [Img1, Img2, Img3, Img4].sort(
    () => Math.random() - 0.5,
);

const TECHNICAL_SPECS = [
    ['Frequency Response', '0.1 Hz – 500 Hz'],
    ['Dynamic Range', '±2 g / ±4 g / ±8 g / ±16 g selectable'],
    ['Sampling Rate', 'Up to 1000 SPS per axis'],
    ['Battery Life', '8 Hours   '],
    ['IP Rating', 'IP6'],
    ['Connectivity', '4G LTE'],
    ['Edge AI', 'CNN-based anomaly detection and classification'],
    ['Operating Temp', '−20 °C to +70 °C'],
];

const Home = () => {
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const interval = window.setInterval(() => {
            setCurrentImage((current) => (current + 1) % HERO_IMAGES.length);
        }, 5000);

        return () => window.clearInterval(interval);
    }, [currentImage]);

    const showPreviousImage = () => {
        setCurrentImage(
            (current) => (current - 1 + HERO_IMAGES.length) % HERO_IMAGES.length,
        );
    };

    const showNextImage = () => {
        setCurrentImage((current) => (current + 1) % HERO_IMAGES.length);
    };

    return (
        <div className="w-full font-sans">
            <section id="gallery" className="group relative max-h-[90vh] w-full overflow-hidden bg-slate-950">
                <img
                    src={HERO_IMAGES[currentImage]}
                    alt="BhuWaivs research and field work"
                    className="block h-auto max-h-[90vh] w-full object-cover object-center transition-opacity duration-500"
                />

                <div className="absolute inset-0  bg-black/25" />

                <button
                    type="button" 
                    aria-label="Previous image"
                    onClick={showPreviousImage}
                    className="absolute left-4 top-1/2 z-30 -translate-y-1/2 cursor-pointer rounded-full bg-white/80 px-4 py-2 text-3xl leading-none text-orange-600 shadow-lg transition-all duration-300 hover:scale-110 hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
                >
                    &#8249;
                </button>

                <button
                    type="button"
                    aria-label="Next image"
                    onClick={showNextImage}
                    className="absolute right-4 top-1/2 z-30 -translate-y-1/2 cursor-pointer rounded-full bg-white/80 px-4 py-2 text-3xl leading-none text-orange-600 shadow-lg transition-all duration-300 hover:scale-110 hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
                >
                    &#8250;
                </button>

                <div className="absolute inset-0 z-20 flex flex-col items-center justify-center px-6 text-center">
                    <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-6xl">
                        BhuWaivs
                    </h1>
                    <div className="mt-5 h-px w-40 bg-orange-500" />
                    <p className="mt-6 text-lg leading-relaxed text-white/90 sm:text-xl">
                        Welcome to BhuWaivs, a pioneering research initiative
                    </p>
                </div>

                <div className="absolute bottom-5 left-1/2 z-20 flex -translate-x-1/2 gap-2">
                    {HERO_IMAGES.map((image, index) => (
                        <button
                            key={image}
                            type="button"
                            aria-label={`Show image ${index + 1}`}
                            onClick={() => setCurrentImage(index)}
                            className={`h-2 rounded-full transition-all duration-300 ${
                                index === currentImage
                                    ? 'w-8 bg-orange-500'
                                    : 'w-2 bg-white/60 hover:bg-white'
                            }`}
                        />
                    ))}
                </div>
            </section>

            <section className="border-b border-slate-200 bg-slate-50 px-6 py-20 sm:px-10 lg:px-12">
                <div className="mx-auto max-w-7xl">
                    <p className="text-sm font-semibold uppercase tracking-widest text-blue-800">
                        What BhuWaivs Does
                    </p>
                    <h2 className="mt-3 max-w-2xl font-serif text-4xl font-bold leading-tight text-slate-900 sm:text-5xl">
                        Sensing that thinks before it transmits.
                    </h2>
                    <p className="mt-4 max-w-3xl text-lg leading-relaxed text-slate-600">
                        Each BhuWaivs node is more than an accelerometer — it&apos;s a compact edge-AI computer that classifies vibration in-place and only wakes the network for what matters.
                    </p>
                    

                    <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                        <article className="rounded-xl border border-slate-200 bg-white p-7 shadow-sm">
                            <div aria-hidden="true" className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-50 text-2xl text-blue-800">▦</div>
                            <h3 className="mt-5 text-lg font-semibold text-slate-900">Tri-Axial MEMS Accelerometer</h3>
                            <p className="mt-3 leading-relaxed text-slate-600">24-bit high-resolution X/Y/Z channels sampled up to 1000 SPS with ±16 g dynamic range.</p>
                        </article>
                        <article className="rounded-xl border border-slate-200 bg-white p-7 shadow-sm">
                            <div aria-hidden="true" className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-50 text-2xl text-blue-800">ϟ</div>
                            <h3 className="mt-5 text-lg font-semibold text-slate-900">On-Device Edge AI</h3>
                            <p className="mt-3 leading-relaxed text-slate-600">Anomaly filtering, PGA extraction and event classification run on-node — bandwidth stays minimal.</p>
                        </article>
                        <article className="rounded-xl border border-slate-200 bg-white p-7 shadow-sm">
                            <div aria-hidden="true" className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-50 text-2xl text-blue-800">◉</div>
                            <h3 className="mt-5 text-lg font-semibold text-slate-900"> 4G/ Ethernet</h3>
                            <p className="mt-3 leading-relaxed text-slate-600">Multi-transport telemetry with adaptive duty-cycle. Reaches the cell tower even from remote gorges.</p>
                        </article>
                        <article className="rounded-xl border border-slate-200 bg-white p-7 shadow-sm">
                            <div aria-hidden="true" className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-50 text-2xl text-blue-800">⬡</div>
                            <h3 className="mt-5 text-lg font-semibold text-slate-900">8 Hours Battery Backup</h3>
                            <p className="mt-3 leading-relaxed text-slate-600">Hermetic enclosure survives monsoon, dust and salt spray recharging battery.</p>
                        </article>
                    </div>
                </div>
            </section>

            <section className="bg-slate-900 px-6 py-20 text-slate-100 sm:px-10 lg:px-12">
                <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[0.95fr_1.35fr] lg:items-start lg:gap-12">
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-widest text-teal-400">
                            Technical Specifications
                        </p>
                        <h2 className="mt-3 font-serif text-4xl font-bold leading-[1.05] text-white sm:text-5xl">
                            Institutional-grade hardware. Field-hardened firmware.
                        </h2>
                        <p className="mt-4 leading-relaxed text-slate-300">
                            Every unit ships pre-calibrated against IIT Roorkee&apos;s certified shake-table and undergoes seismic response validation before dispatch.
                        </p>
                        <img
                            src={Img5}
                            alt="BhuWaivs hardware and field research"
                            className="mt-7 aspect-[3/2] w-full rounded-lg border border-slate-700 object-cover"
                        />
                    </div>

                    <dl className="overflow-hidden rounded-xl border border-slate-700 text-sm">
                        {TECHNICAL_SPECS.map(([label, value], index) => (
                            <div
                                key={label}
                                className={`grid grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] items-center gap-4 px-4 py-4 sm:px-5 ${
                                    index % 2 === 0 ? 'bg-slate-800/80' : 'bg-slate-800/40'
                                }`}
                            >
                                <dt className="text-slate-400">{label}</dt>
                                <dd className="text-right font-mono leading-relaxed text-slate-100">
                                    {value}
                                </dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </section>

            <section className="bg-white px-6 py-20 text-slate-900 sm:px-10 lg:px-12">
                <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.85fr_2fr] lg:items-start lg:gap-12">
                    <div>
                        <p className="text-sm font-semibold uppercase tracking-widest text-blue-800">
                            Provenance
                        </p>
                        <h2 className="mt-3 font-serif text-4xl font-bold leading-tight text-slate-900 sm:text-5xl">
                            Born from India&apos;s oldest earthquake engineering department.
                        </h2>
                        <p className="mt-5 text-lg leading-relaxed text-slate-600">
                           Shriseismic Technology was incubated at TIDE, IIT Roorkee. Our founding research team built the country&apos;s first indigenous MEMS-based structural health monitoring stack.
                        </p>
                    </div>

                    <div>
                        <div className="grid gap-4 md:grid-cols-3">
                            <article className="rounded-xl border border-slate-200 bg-slate-50 p-6">
                                <img src={SharmaPortrait} alt="Prof. M. L. Sharma" className="h-16 w-16 rounded-full object-cover" />
                                <h3 className="mt-5 font-semibold text-slate-900">Prof. M. L. Sharma</h3>
                                <p className="mt-1 text-sm text-slate-600">CMD</p>
                            </article>
                            <article className="rounded-xl border border-slate-200 bg-slate-50 p-6">
                                <img src={VivekPortrait} alt="Vivek Bansal" className="h-16 w-16 rounded-full object-cover" />
                                <h3 className="mt-5 font-semibold text-slate-900">Vivek Bansal</h3>
                                <p className="mt-1 text-sm text-slate-600">Head of Firmware &amp; Edge AI</p>
                            </article>
                            
                           <article className="rounded-xl border border-slate-200 bg-slate-50 p-6">
                                <img src={GirishPortrait} alt="Dr. Girish Chandra Joshi" className="h-16 w-16 rounded-full object-cover" />
                                <h3 className="mt-5 font-semibold text-slate-900">Dr. Girish Chandra Joshi</h3>
                                <p className="mt-1 text-sm text-slate-600">Director</p>
                            </article>
                        </div>

                        <ul className="mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
                            {['IIT Roorkee', 'TIDE Incubator', , 'IP68 Certified'].map((credential) => (
                                <li key={credential} className="rounded-xl border border-slate-200 px-4 py-4 text-center text-sm font-medium text-slate-700">
                                    {credential}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

            <section className="bg-[#17479b] px-6 py-16 text-white sm:px-10 lg:px-12">
                <div className="mx-auto grid max-w-7xl items-center gap-8 md:grid-cols-[1fr_auto] md:gap-12">
                    <div>
                        <h2 className="font-serif text-3xl font-bold leading-tight sm:text-4xl">
                            Ready to see BhuWaivs in action?
                        </h2>
                        <p className="mt-3 max-w-3xl text-lg leading-relaxed text-blue-100">
                            Launch the demo dashboard — 10 simulated sensors across India stream live to your screen.
                        </p>
                    </div>
                    <Link
                        to="/live-graph"
                        className="inline-flex min-h-14 items-center justify-center gap-5 rounded-xl bg-white px-7 py-4 font-semibold text-blue-900 no-underline transition-colors hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-blue-800"
                    >
                        Open Live Dashboard
                        <span aria-hidden="true" className="text-xl">→</span>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Home;
